import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Post } from '../services/http';
import { validateForm } from '../services/validate';
import UploadImage from '../services/upload-image';
import './dialog.css';
import UserIcon from '../images/white-user.png';

export default function LoginButtonDialog({ campaignId, campaignSlug }) {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState(null);
    const [partnerLink, setPartnerLink] = React.useState(null);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const config = useStoreState((state) => state.config);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    const createPartnerLink = (event) => {
        const partnerUserName = document.getElementById(event.target.id).value;
        const linkReady = config.frontDomain + campaignSlug + '/' + partnerUserName;
        setPartnerLink(linkReady);
    };

    const createAmbassador = async () => {
        console.log('image', image);
        let validationResult = validateForm(['first-name', 'last-name', 'cell', 'email', 'goal', 'slug', 'password'], image);
        if (!validationResult.result) {
            openInfoPopup({ notice: validationResult.notice, reload: false, btnName: 'OK' });
            return;
        }
        let firstName = document.getElementById('first-name').value;
        let lastName = document.getElementById('last-name').value;
        let cell = document.getElementById('cell').value;
        let email = document.getElementById('email').value;
        let goal = Number(document.getElementById('goal').value);
        let personalMessage = document.getElementById('personal-message').value;
        let slug = document.getElementById('slug').value;
        let password = document.getElementById('password').value;
        let additionalComments = document.getElementById('additional-comments').value;
        const result = await Post('/api/donation/CreateNewAmbassador', { goal, password, additionalComments, personalMessage, slug, phoneNumber: cell, email, firstName, secondName: lastName, campaignId: campaignId, img: image });
        if (result.result) {
            openInfoPopup({ notice: 'Created', reload: false, btnName: 'OK' });
        } else {
            openInfoPopup({ notice: result.message, reload: false, btnName: 'OK' });
        }
    };

    return (
        <div className='flex'>
            <div className="header__user-block user-block" onClick={handleClickOpen}>
                <div style={{ width: '80px' }}>
                    <button type="submit" style={{ background: '#1979BE', display: 'flex', padding: '5px', borderRadius: '6px' }} className="login_button"> <img src={UserIcon} alt="" /> <span className="roboto weight-400 f-16" style={{ display: 'inline-block', paddingLeft: '5px', paddingRight: '5px' }}>Login</span></button>
                </div>
            </div>
            <div className="header__user-block user-block" style={{marginLeft:'5%'}}>
                <select className='rubik weight-400 f-18' style={{borderRadius: '6px'}}>
                    <option className="login_button">EN</option>
                </select>
            </div>
            <div id="popup-login" className={open ? 'popup _open' : 'popup'}>
                <div class="popup__body">
                    <div class="popup__content" style={{ position: 'relative', maxWidth: '50rem' }}>
                        <div class="login-form">
                            <h3 class="para-border-bottom para-blue">Login</h3>
                            <p class="remove-margin-bottom" onClick={handleClose} style={{ cursor: 'pointer', color: 'red', position: 'absolute', top: 10, right: 10 }}><CloseIcon style={{ fontSize: '30px' }} /></p>
                            <div class="center-text-and-line">
                                <div class="form-button">
                                    <a rel="noreferrer" target="_blank" href={config.dashboardDomain}>
                                        <div style={{ textAlign: 'center' }}>
                                            <button class="login_button" type="submit">Login {'>'}</button>
                                        </div>
                                    </a>
                                </div>
                                <div class="or-devider"><span>Or</span></div>
                                <a href="/sign-up-campaign">
                                    <button class="create_account" type="button" style={{ width: '100%' }}>
                                        create account  {'>'}
                                    </button>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
